import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed } from 'vue';
import { LAYOUT } from '../../../constants/render';
import { useBasicStore } from '../../../stores/basic';
import { useRoomStore } from '../../../stores/room';
import { storeToRefs } from 'pinia';
import { useI18n } from '../../../locales';
import { IconButtonLayout } from '../../../constants/room';
import IconButton from '../../common/base/IconButton.vue';
import LayoutIcon from '../../common/icons/LayoutIcon.vue';
import '../../../directives/vClickOutside';
import { roomService } from '../../../services';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutControl',
  setup(__props) {

const { t } = useI18n();

const basicStore = useBasicStore();
const { layout } = storeToRefs(basicStore);
const roomStore = useRoomStore();
const { streamNumber } = storeToRefs(roomStore);

const showLayoutList: Ref<boolean> = ref(false);
const isStreamNumberLessThanTwo = computed(() => streamNumber.value < 2);
const layoutControlConfig = roomService.getComponentConfig('LayoutControl');

function handleClick(layout: any) {
  basicStore.setLayout(layout);
}

function handleClickLayoutIcon() {
  if (isStreamNumberLessThanTwo.value) {
    return;
  }
  showLayoutList.value = !showLayoutList.value;
}

function handleClickOutSide() {
  if (showLayoutList.value) {
    showLayoutList.value = false;
  }
}

return { __sfc: true,t, basicStore, layout, roomStore, streamNumber, showLayoutList, isStreamNumberLessThanTwo, layoutControlConfig, handleClick, handleClickLayoutIcon, handleClickOutSide, LAYOUT, IconButtonLayout, IconButton, LayoutIcon }
}

})